/*
 * Heldenglueck B2B - Mindestbestellwert und Verkaufseinheiten. Fassung 5, 03.09.2026
 *
 * Aenderung: keine Mengen-Obergrenze mehr in den VE-Regeln. Grenze ist nur
 * noch der Lagerbestand, den Shopify selbst prueft.
 *
 *   A) Sperre des Checkouts unter 350 EUR netto, auch durch Shadow DOM hindurch.
 *   B) Autokorrektur der Mengen auf die Verkaufseinheit ueber /cart/change.js.
 *      Hoch wird aufgerundet, runter abgerundet. 4 minus eins ergibt 0.
 *
 * Diagnose in der Browser-Konsole: hgStatus()
 * Sicherer Grundzustand: Ohne Warenkorbdaten ist der Checkout FREI.
 */

(function () {
  var MIN_ORDER = 35000 // Cent, netto

  var VE_RULES = [
    { tag: 'VE-4', step: 4 },
    { tag: 'VE-10', step: 10 },
    { tag: 'VE-12', step: 12 },
    { tag: 'VE-24', step: 24 }
  ]

  var state = { total: 0, items: 0, geladen: false, korrigiert: 0 }
  var mengen = {}
  var produkte = {}
  var korrekturLaeuft = false

  window.hgUnterLimit = false

  window.hgStatus = function () {
    return {
      geladen: state.geladen,
      warenkorbNetto: (state.total / 100).toFixed(2) + ' EUR',
      positionen: state.items,
      unterLimit: window.hgUnterLimit,
      gefundeneKasseButtons: checkoutElemente().length,
      korrekturen: state.korrigiert
    }
  }

  function istCheckoutElement(el) {
    if (!el || el.nodeType !== 1) return false

    var tag = el.tagName
    if (tag !== 'A' && tag !== 'BUTTON' && tag !== 'INPUT') return false

    var href = el.getAttribute('href') || ''
    if (href.indexOf('/checkout') !== -1) return true

    var name = (el.getAttribute('name') || '').toLowerCase()
    if (name === 'checkout' || name === 'goto_pp' || name === 'goto_gc') return true

    var kennung = ((el.getAttribute('class') || '') + ' ' + (el.id || '')).toLowerCase()
    if (kennung.indexOf('checkout') !== -1) return true

    var text = (el.textContent || el.value || '').trim().toLowerCase()
    if (text.length > 0 && text.length < 40) {
      if (text.indexOf('kasse') !== -1 || text.indexOf('checkout') !== -1 || text.indexOf('bestellung abschlie') !== -1) return true
    }

    return false
  }

  function sammle(wurzel, treffer) {
    var alle
    try {
      alle = wurzel.querySelectorAll('*')
    } catch (e) {
      return
    }

    Array.prototype.forEach.call(alle, function (el) {
      if (el.shadowRoot) sammle(el.shadowRoot, treffer)
      if (istCheckoutElement(el)) treffer.push(el)
    })
  }

  function checkoutElemente() {
    var treffer = []
    try {
      sammle(document, treffer)
    } catch (e) {}
    return treffer
  }

  function alteLeisteEntfernen() {
    var reste = document.querySelectorAll('.hg-min-order')
    Array.prototype.forEach.call(reste, function (el) {
      if (el.parentElement) el.parentElement.removeChild(el)
    })
  }

  function sperreAnwenden() {
    checkoutElemente().forEach(function (button) {
      if (window.hgUnterLimit) {
        button.setAttribute('aria-disabled', 'true')
        button.dataset.hgBlocked = '1'
        button.style.opacity = '0.45'
        button.style.cursor = 'not-allowed'
        if (button.tagName !== 'A') button.setAttribute('disabled', 'disabled')
      } else if (button.dataset.hgBlocked === '1') {
        button.removeAttribute('disabled')
        button.removeAttribute('aria-disabled')
        delete button.dataset.hgBlocked
        button.style.opacity = ''
        button.style.cursor = ''
      }
    })
  }

  function anwenden() {
    window.hgUnterLimit = state.geladen && state.items > 0 && state.total < MIN_ORDER
    sperreAnwenden()
    alteLeisteEntfernen()
  }

  function klickFaenger(event) {
    if (!window.hgUnterLimit) return

    var pfad = typeof event.composedPath === 'function' ? event.composedPath() : [event.target]
    var treffer = null

    for (var i = 0; i < pfad.length; i++) {
      if (istCheckoutElement(pfad[i])) {
        treffer = pfad[i]
        break
      }
    }

    if (!treffer) return

    event.preventDefault()
    event.stopPropagation()
  }

  function regelAusTags(tags) {
    if (!tags) return null
    for (var i = 0; i < VE_RULES.length; i++) {
      if (tags.indexOf(VE_RULES[i].tag) !== -1) return VE_RULES[i]
    }
    return null
  }

  function produktLaden(handle) {
    if (!produkte[handle]) {
      produkte[handle] = fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) {
          return r.ok ? r.json() : null
        })
        .catch(function () {
          return null
        })
    }
    return produkte[handle]
  }

  function zielMenge(neu, alt, step) {
    if (neu <= 0) return 0

    var ziel

    if (alt !== undefined && neu < alt) {
      ziel = Math.floor(neu / step) * step
      if (ziel < step) return 0
    } else {
      ziel = Math.ceil(neu / step) * step
      if (ziel < step) ziel = step
    }

    return ziel
  }

  function mengenPruefen(cart) {
    if (korrekturLaeuft) return

    var aufgaben = cart.items.map(function (item) {
      return produktLaden(item.handle).then(function (produkt) {
        var regel = produkt ? regelAusTags(produkt.tags) : null
        if (!regel) return null

        var ziel = zielMenge(item.quantity, mengen[item.key], regel.step)
        if (ziel === item.quantity) return null

        return { key: item.key, quantity: ziel }
      })
    })

    Promise.all(aufgaben).then(function (ergebnisse) {
      var korrektur = ergebnisse.filter(function (e) {
        return e !== null
      })[0]

      cart.items.forEach(function (item) {
        mengen[item.key] = item.quantity
      })

      if (!korrektur) return

      korrekturLaeuft = true
      state.korrigiert++
      mengen[korrektur.key] = korrektur.quantity

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: korrektur.key, quantity: korrektur.quantity })
      })
        .then(function (r) {
          return r.ok ? r.json() : null
        })
        .then(function (neuerCart) {
          korrekturLaeuft = false
          if (!neuerCart) return

          state.total = neuerCart.total_price
          state.items = neuerCart.item_count
          anwenden()

          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }))
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: neuerCart } }))

          if (window.location.pathname.indexOf('/cart') === 0) window.location.reload()
        })
        .catch(function () {
          korrekturLaeuft = false
        })
    })
  }

  var holen = null

  function aktualisieren() {
    if (holen) window.clearTimeout(holen)

    holen = window.setTimeout(function () {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) {
          return r.ok ? r.json() : null
        })
        .then(function (cart) {
          if (!cart) return
          state.total = cart.total_price
          state.items = cart.item_count
          state.geladen = true
          anwenden()
          mengenPruefen(cart)
        })
        .catch(function () {
          state.geladen = false
          window.hgUnterLimit = false
          sperreAnwenden()
        })
    }, 300)
  }

  function netzBeobachten() {
    var originalFetch = window.fetch

    if (typeof originalFetch === 'function') {
      window.fetch = function () {
        var ergebnis = originalFetch.apply(this, arguments)

        try {
          var erstes = arguments[0]
          var url = typeof erstes === 'string' ? erstes : erstes && erstes.url
          if (typeof url === 'string' && url.indexOf('/cart/') !== -1) {
            ergebnis.then(function () {
              aktualisieren()
            })
          }
        } catch (e) {}

        return ergebnis
      }
    }

    var originalOpen = XMLHttpRequest.prototype.open
    XMLHttpRequest.prototype.open = function (methode, url) {
      try {
        if (typeof url === 'string' && url.indexOf('/cart/') !== -1) {
          this.addEventListener('load', function () {
            aktualisieren()
          })
        }
      } catch (e) {}

      return originalOpen.apply(this, arguments)
    }
  }

  function start() {
    netzBeobachten()
    aktualisieren()

    document.addEventListener('click', klickFaenger, true)

    document.addEventListener(
      'submit',
      function (event) {
        if (!window.hgUnterLimit) return
        var form = event.target
        if (!form || !form.action) return
        if (form.action.indexOf('/checkout') !== -1) {
          event.preventDefault()
          return
        }
        if (form.action.indexOf('/cart') !== -1 && form.querySelector('[name="checkout"]')) event.preventDefault()
      },
      true
    )

    var wartet = false
    var beobachter = new MutationObserver(function () {
      if (wartet) return
      wartet = true
      window.requestAnimationFrame(function () {
        wartet = false
        anwenden()
      })
    })

    if (document.body) beobachter.observe(document.body, { childList: true, subtree: true })

    document.addEventListener('cart:quantity', aktualisieren)
    document.addEventListener('cart:updated', aktualisieren)
    window.addEventListener('pageshow', aktualisieren)

    console.log('[Heldenglueck] Sperre aktiv. Status mit hgStatus()')
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start)
  } else {
    start()
  }
})()
